import {
  FormControl, FormControlLabel, FormLabel, Radio, RadioGroup,
} from '@material-ui/core';
import React from 'react';
import ErrorText from './ErrorText';

interface YesNoProps {
  title: string;
  name: string;
  value: string | undefined;
  error: boolean;
  handleChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export default function YesNoChoiceControl(props: YesNoProps) : JSX.Element {
  const {
    title, name, value, error, handleChange,
  } = props;

  return (
    <FormControl component="fieldset" id={`yes-no-${name}`}>
      <FormLabel component="legend" style={{ color: 'black', fontWeight: 'bold' }}>{title}</FormLabel>
      <RadioGroup aria-label={name} name={name} value={value} onChange={handleChange}>
        <FormControlLabel value="true" control={<Radio />} label="Yes" />
        <FormControlLabel value="false" control={<Radio />} label="No" />
      </RadioGroup>
      <ErrorText error={error} errorText="You must select an option" />
    </FormControl>
  );
}
